import axiosApiInstance from './request';
const apiVersion = 'v2';

const getMilestoneRecordService = async (params: any) => {
  const headers = { 'Content-Type': 'application/json' };
  let response = {};
  try {
    response = await axiosApiInstance.get(`/milestone/`, {
      headers,
      params: params,
      apiVersion
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};

const postMilestoneRecordService = async (payload: any) => {
  const headers = { 'Content-Type': 'application/json' };
  let response = {};
  try {
    response = await axiosApiInstance.post(`/milestone/`, payload, {
      headers,
      apiVersion
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};
const putMilestoneRecordService = async (id: any, payload: any) => {
  const headers = { 'Content-Type': 'application/json' };
  let response = {};
  try {
    response = await axiosApiInstance.put(`/milestone/${id}/`, payload, {
      headers,
      apiVersion
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};

const getTimesheetRecordService = async (payload: any) => {
  const paramsSend = payload.payload ? payload.payload : payload;
  const headers = { 'Content-Type': 'application/json' };
  let response = {};
  try {
    response = await axiosApiInstance.get(`/timesheet/`, {
      headers,
      params: paramsSend,
      apiVersion
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};

const postTimesheetRecordService = async (payload: any) => {
  const headers = { 'Content-Type': 'multipart/form-data' };
  let response = {};
  try {
    response = await axiosApiInstance.post(`/timesheet/`, payload, {
      headers,
      apiVersion
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};
const putTimesheetRecordService = async (payload: any, id: any) => {
  const headers = { 'Content-Type': 'multipart/form-data' };
  let response = {};
  try {
    response = await axiosApiInstance.put(`/update-timesheet/${id}/`, payload, {
      headers,
      apiVersion
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};
const patchTimesheetRecordService = async (payload: any, id: any) => {
  const headers = { 'Content-Type': 'multipart/form-data' };
  let response = {};
  try {
    response = await axiosApiInstance.put(`/timesheet/${id}/`, payload, {
      headers,
      apiVersion
    } as any);
  } catch (error: any) {
    response = error;
  }
  return response;
};

export {
  getTimesheetRecordService,
  postTimesheetRecordService,
  getMilestoneRecordService,
  postMilestoneRecordService,
  patchTimesheetRecordService,
  putTimesheetRecordService,
  putMilestoneRecordService
};
